import { Moon, Star, Heart, Flower2, Sparkles, Flame, Feather, Cat, Rabbit, Crown, Gem, Leaf } from "lucide-react";

export const AVATAR_ICONS = {
  moon: Moon, star: Star, heart: Heart, flower: Flower2, sparkles: Sparkles, flame: Flame,
  feather: Feather, cat: Cat, rabbit: Rabbit, crown: Crown, gem: Gem, leaf: Leaf,
};

export const AvatarBadge = ({ avatar, size = 40, className = "", testid }) => {
  const [bg, moon, ring] = avatar?.colors ?? ["#2b2d6e", "#f2f0ea", "#c8a2ff"];
  const Icon = AVATAR_ICONS[avatar?.icon] ?? Moon;
  return (
    <span className={`relative inline-block shrink-0 ${className}`} style={{ width: size, height: size }} data-testid={testid}
      title={avatar?.label || avatar?.character || ""}>
      <svg viewBox="0 0 100 100" className="w-full h-full" aria-hidden="true">
        <circle cx="50" cy="50" r="47" fill={bg} stroke={ring} strokeWidth="6" />
        <circle cx="50" cy="50" r="38" fill="none" stroke={ring} strokeOpacity=".45" strokeWidth="1.5" strokeDasharray="2 4" />
        <path d="M62 20 A32 32 0 1 0 62 80 A26 26 0 1 1 62 20Z" fill={moon} opacity=".95" />
      </svg>
      <Icon className="absolute text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]"
        style={{ width: size * 0.32, height: size * 0.32, right: size * 0.2, top: size * 0.34 }} />
    </span>
  );
};
